// extracted by css-extract-rspack-plugin
export default {"fab":"fab-LII2nx"};